import { newProjectId, newProjectName } from '~/constant'
import * as ActionTypes from '~/actions/ActionTypes'
import * as API from '~/ServerAPI'
import * as LatestProjectName from '~/cookieServices/LatestProjectName'
import { selectActiveProjectId, selectCanModifyActiveProject } from '~/selectors/projectData'
import { saveProject } from './saveProject'
import { fetchNextProjectName } from './fetchNextProjectName'

export const renameProject = (id, name, createProject = true) => async (dispatch, getState) => {
  try {
    const state = getState()
    const activeProjectId = selectActiveProjectId(state)

    if (id === activeProjectId && !selectCanModifyActiveProject(state)) {
      return
    }

    const nextProjectName = await dispatch(fetchNextProjectName(name ?? newProjectName))

    if (activeProjectId === id) {
      LatestProjectName.set(nextProjectName)
    }
    dispatch({ type: ActionTypes.PROJECTS_SET_ACTIVE_NAME,
      payload: { name: nextProjectName, projectId: id } })

    if (id !== newProjectId) {
      await API.renameProject(id, nextProjectName)
    } else if (createProject) {
      await dispatch(saveProject())
    }
  } catch (e) {
    console.error(`Failed to rename project ${id}`)
  }
}
